import * as React from 'react';
import clsx from 'clsx';
import {Button} from 'onboarding-components';

import {useTranslation} from 'common/i18n/hooks';

import {HeaderProps, SectionProps} from '../events/types';
import styles from './index.module.styl';
import {SectionHeader} from './section-header';

export const SectionContent = (props: React.PropsWithChildren<HeaderProps & SectionProps>) => {
  const {t} = useTranslation();
  const {
    children,
    onNext,
    nextCTA,
    disableNext = false,
    onSkip,
    skipCTA,
    sectionLabel,
    scrollable,
    headerComponent,
    className,
    disabledCallback,
    ...headerProps
  } = props;

  return (
    <div className={clsx(styles.subStepPadding, className)}>
      {headerComponent}
      <div className={styles.section}>
        {sectionLabel && <div className={styles.substep}>{sectionLabel}</div>}
        <div className={styles.sectionContent}>
          <SectionHeader {...headerProps} />
          {children}
          <div
            className={styles.footerButtons}
            onClick={() => {
              if (disableNext && disabledCallback) {
                disabledCallback();
              }
            }}
          >
            {onNext && (
              <Button onClick={onNext} size='small' disabled={disableNext}>
                {nextCTA || t(`onboarding.next`)}
              </Button>
            )}
            {onSkip && (
              <Button onClick={onSkip} variant={`inline`} includeArrow={false} size='small'>
                {skipCTA || t(`onboarding.skip`)}
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
